import { useContext, useEffect, useState } from "react"
import { HomeService } from "../../services/homeService"
import { LangContext } from "../../providers/LangContext";
import { LoaderSpinner } from '../commons/loaderSpinner/loaderSpinner';
import Carousel from "../commons/carousel/carousel";
import "./home.scss";

export default function Home(){

    const lang = useContext(LangContext);
    const[slides,setSlides] = useState<any[]>([])
    const homeService= HomeService();
    const [loading, setLoading] = useState(true)
    useEffect(()=>{
        const fetchSlides = async () => {
            setLoading(true);
            try {
                const slides:any = await homeService.getCarouselData(lang.lang) ;
                setSlides(slides.data);
            } catch (error) {
                console.error(error);
            }finally{
                setLoading(false);
            }
        }
        fetchSlides()
    },[lang.lang])
    return(
        <>
            {loading ? (
            <LoaderSpinner visible={true} />
            ) : (
                <Carousel slides={slides}/>
            )}
        </>
    )
}